<template>
  <div :class="$style.container"
       style="display: flex;flex-direction: column;padding: 0 20px"
       v-loading.fullscreen.lock.body="loading"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">

    <div
        style="width: 100%;flex-shrink: 0;padding: 20px 0 10px 0;background:#fff;text-align: center;position: relative;">

      <div style="position: absolute;left: 0">
        <div style="padding-top: 8px;font-size: 22px;">客户资料库</div>
      </div>

      <div  style="text-align: center">
        <div>
          <el-button-group>
            <el-button @click="dianji0">地图模式</el-button>
            <el-button @click="dianji" v-if="clientObj.showInstitution">医疗机构</el-button>
            <el-button style="color: #409EFF;border-color: #c6e2ff;background-color: #ecf5ff;"
                       v-if="clientObj.showStore">零售终端
            </el-button>
            <el-button @click="dianji2" v-if="clientObj.showDistributor">分销客户</el-button>
          </el-button-group>
        </div>
      </div>
      <div style="position: absolute;right: 0;top:20px"  v-if="this.role!='staff'">
        <div align="right" style="display: flex;align-items: center;justify-content: space-between;">
          <span style="font-weight: bold;margin-right: 10px;">人员</span>
          <inputSelect :handleSelectInput="handleSelectInputClick" :key="timer" v-if="jinyong==false"
                       style="flex-grow:1 "></inputSelect>
          <el-input v-else v-model="name" disabled style="width: 150px;flex-grow:1 "></el-input>
        </div>
      </div>
    </div>


    <el-container v-if="StoreList.length != 0" id="styleClass" style="flex-grow: 1;overflow: hidden;">


      <el-aside width="415px" style="background-color: #fff;height: 100%;overflow-y: auto">
        <div style="width: 400px;margin-top: -24px">
          <div style="width: 400px;margin-top: 40px"v-infinite-scroll="load">
            <div
                :style="{cursor: 'pointer',backgroundColor:mydiv==index?'#ecf3fc':'#fff',borderColor:mydiv==index?'#4A90E2':'#ededed'}"
                class="mydiv" :tabindex="index.toString()" v-for="(item,index) in StoreList"
                @click="StoreAction(item,index)">
              <el-row :span="24">
                <el-col :span="20">
                                     <span
                                         style="color: #fff;border: #3998f7 1px solid;background-color: #3998f7;padding: 1px 2px 1px 6px;position: relative;top: 12px;left: 17px;"
                                         v-if="item.segment_name!==''">
                                            {{ item.segment_name }}
                                        </span>
                  <span v-else="item.segment_name==''"></span>
                  <span
                      :style="{color: '#4D586D',fontSsize:'15px',position:'relative',top:'12px',left:'21px',fontWeight:mydiv==index?'bold':'normal'}">
                                          {{ item.store_name }}
                                    </span>
                </el-col>
                <el-col :span="4" v-if="searchType=='直属辖区'&&item.alias!=null">
                                     <span
                                         style="color: #4D586D;font-size: 12px;font-weight:bold;padding-left: -10px;position: relative;top: 12px;right:10px;float:right;background-color: #ff9901;border: 1px solid #ff9901;border-radius: 3px;color: #fff;padding: 2px 2px">
                                        {{ item.alias }}
                                    </span>
                </el-col>
                <el-col :span="4" v-if="searchType=='所有下属'&&item.alias!=null">
                                     <span
                                         style="color: #4D586D;font-size: 12px;font-weight:bold;padding-left: -10px;position: relative;top: 12px;right:10px;float:right;background-color: #ff9901;border: 1px solid #ff9901;border-radius: 3px;color: #fff;padding: 2px 2px">
                                        {{ item.alias }}
                                    </span>
                </el-col>
                <el-col :span="4" v-if="searchType=='部门'&&item.alias!=null">
                                     <span
                                         style="color: #4D586D;font-size: 12px;font-weight:bold;padding-left: -10px;position: relative;top: 12px;right:10px;float:right;background-color: #ff9901;border: 1px solid #ff9901;border-radius: 3px;color: #fff;padding: 2px 2px">
                                        {{ item.alias }}
                                    </span>
                </el-col>

              </el-row>
              <el-row style="margin-top: 20px">
                <el-col :span="20">
                                    <span
                                        style="margin-top: 20px;position:relative;left:19px;font-size: 13px;color: #B0B5B9">
                                    {{ item.address }}
                                    </span>
                </el-col>
                <el-col :span="4" style="padding-right: 16px;color: #B0B5B9;float:right">
                  <img src="../../assets/images/tu4.png" alt="" style="float: right;margin-top:4px;">
                </el-col>
              </el-row>
              <el-row style="margin-top: 10px">
                <el-col :span="9">
                        <span style="color: #7ED321;font-size: 13px;padding-left: 19px">
                            {{ item.retailstore_grade_name }}
                        </span>
                </el-col>
                <el-col :span="15">
                        <span style="color: #4A90E2;font-size: 13px;text-align:right;padding-left: 80px"
                              v-if="item.inspection_num!=0 && item.clerk_num!=0">
                           店员{{ item.clerk_num }}人 ｜ 本月巡店{{ item.inspection_num }}次
                        </span>
                  <span style="color: #4A90E2;font-size: 13px;text-align:right;padding-left: 80px"
                        v-else-if="item.inspection_num==0 && item.clerk_num==0">
                              <span style="font-size: 13px;color: red"> 暂无店员</span> ｜ <span
                      style="font-size: 13px;color: red">本月尚未巡店</span>
                        </span>
                  <span style="color: #4A90E2;font-size: 13px;text-align:right;padding-left: 80px"
                        v-else-if="item.clerk_num!=0 ">
                           店员{{ item.clerk_num }}人 ｜ <span style="font-size: 13px;color: red">本月尚未巡店</span>
                        </span>
                  <span style="color: #4A90E2;font-size: 13px;text-align:right;padding-left: 80px"
                        v-else-if="item.inspection_num!=0">
                           <span style="font-size: 13px;color: red"> 暂无店员</span> ｜ 本月巡店{{ item.inspection_num }}次
                        </span>
                </el-col>
              </el-row>
              <el-row style="padding:10px 0 10px 0">

                <el-col style="padding-left: 19px;padding-right: 10px">
                                    <span v-for=" item2 in item.productArray"
                                          style="background-color: #c8abed;border: 1px solid #c8abed;color: #fff;font-size: 11px;border-radius:3px;margin:2px;padding:4px 8px;line-height:15px;display:inline-block">
                                        {{ item2.value1 }}
                                    </span>
                </el-col>
              </el-row>
            </div>


          </div>
        </div>
      </el-aside>
      <el-main style="margin-top: 10px;margin-left: 20px;padding-bottom:10px;background-color: #fff;overflow-y: auto">

          <div style="margin-bottom: 45px">
            <div style="float: left;margin-top: 4px">
                        <span style="color: #4A90E2;font-size: 18px;font-weight: bold">
                            <span
                                style="color: #fff;border: #3998f7 1px solid;background-color: #3998f7;padding: 0px 6px"
                                v-if="storeInfoAction.segment_name!=''">{{ storeInfoAction.segment_name }}</span>
                            <span v-else></span>
                          {{ storeInfoAction.store_name }}
                        </span>
            </div>
            <div style="width: 50px;float: left;margin-left: 20px;padding-top: 3px">
                        <span
                            style="font-size: 12px;background-color: #ff9901;border: 1px solid #ff9901;border-radius: 3px;color: #fff;padding: 0 2px"
                            v-if="storeInfoAction.alias!=''&&searchType=='直属辖区'">
                            {{ storeInfoAction.alias }}
                        </span>
              <span
                  style="font-size: 12px;background-color: #ff9901;border: 1px solid #ff9901;border-radius: 3px;color: #fff;padding: 0 2px"
                  v-if="storeInfoAction.alias!=''&&searchType=='所有下属'">
                            {{ storeInfoAction.alias }}
                        </span>
              <span v-if="storeInfoAction.alias!=''&&searchType=='自己'">

                        </span>
              <span v-if="storeInfoAction.alias==''">

                            </span>
            </div>
            <div style="width: 57px;float: right;padding-top: 0">

              <el-button size="mini"
                         style="background-color: #ff9901;border: 1px solid #ff9901;color: #fff;float: right"
                         @click.stop="details" @click="dialogVisible2=true">详情
              </el-button>
            </div>
            <div style="width: 57px;float: right;margin-right: 10px;padding-top: 6px"
                 v-if="storeInfoAction.account_status=='ACTIVE'">
                         <span style="color: #FF6F61;font-size: 10px;border-bottom: #FF6F61 3px double">
                             目标客户
                         </span>
            </div>
            <div style="width: 57px;float: right;margin-right: 10px;padding-top: 10px"
                 v-else="storeInfoAction.account_status=='INACTIVE'">
                         <span>

                         </span>
            </div>
          </div>


          <div style="border: 1px dashed #ededed;margin-top: -5px">

          </div>

          <!-- 地图-->
          <div :style="{width:'100%',height:'300px'}" style="text-align: center;margin-top: 17px">
            <el-amap
                vid="amapDemo"
                :center="center"
                :zoom="zoom"
                :amapManager="amapManager"
                class="amap-demo"
                :plugin="plugin"
            >
              <el-amap-marker
                  :position="center.position" :template="center.template" v-for="center in centers">
              </el-amap-marker>
            </el-amap>
          </div>

          <!--                        location-->
          <div :style="{width:'100%',height:'62px',padding:'10px 0px',overflow:'hidden',position:'relative'}">
            <div style="width:20px;height: 20px;position: absolute;top: 32px;left:0px; cursor:pointer;"
                 @click="locationLeftBut">
              <img src="../../assets/images/locationLeft.png" style="width: 20px;height: 20px;">
            </div>
            <!--                        <div style="width:50px;height: 50px;float: left;margin-top:6px;margin-left: -50px;cursor:pointer;" @click.stop="addLocation" @click="dialog1 = true">-->
            <!--                            <img src="../../assets/images/locationAdd.png"style="width: 50px;height: 50px;" >-->
            <!--                        </div>-->
            <div style="float:left;height: 62px;margin-left:3%;width:90%;overflow:hidden">
              <div style=";;height: 62px;position: relative;white-space: nowrap;transition: .3s;"
                   :style="{'left':marginValue1 +'px' ,'width':widthLocation}"
              >
                <div
                    :style="{width: '350px',height: '60px',border:'1px solid #ccc',float: 'left',marginLeft: '10px',marginBottom: '10px',backgroundColor:mydiv1===j?'#ecf3fc':'#fff',borderColor:mydiv1===j?'#4A90E2':'#ededed',}"
                    v-for="(item,j) in locationInfo"
                    @click="InstitutionClient1(item,j)" class="mydiv1"
                    style="display: inline-block;white-space: nowrap;"
                >
                  <div style="float: left">
                    <p style="margin:20px;background: #999;color: #fff;border-radius: 50%;width: 20px;height: 20px;text-align: center;line-height: 20px;">
                      {{ j + 1 }}</p>
                  </div>
                  <div style="float: left">
                    <p style="padding: 10px 10px;margin: 0;color: #4A4A4A;font-size: 16px;width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;padding-left: 0px;">
                      {{ item.location_name }}</p>
                    <p style="padding: 0px 10px;margin: 0;color: #B0B5B9;font-size: 14px;width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;padding-left: 0px;">
                      {{ item.address }}</p>
                  </div>
                  <div style="float: right" v-if="item.primary == 'T'">
                    <span style="font-size: 14px;color:#7ED321;margin:10px;line-height: 85px;">主要</span>
                  </div>
                </div>
              </div>
            </div>
            <div style="width:20px;height: 20px;position: absolute;top: 32px;right:0px; cursor:pointer;"
                 @click="locationRightBut">
              <img src="../../assets/images/locationRight.png" style="width: 20px;height: 20px;">
            </div>
          </div>


          <div class="message" style="margin-top: 20px;">
            <el-row>
              <el-col :span="3" style="font-size: 14px;font-weight: bold;margin-top: 12px">名称</el-col>
              <el-col :span="21" style="color: #4A90E2;font-size: 14px;position: relative;top: 10px">
                {{ storeInfoAction.store_name }}
              </el-col>
            </el-row>
            <!--                        <el-row style="margin-top:24px">-->
            <!--                            <el-col :span="3"  style="font-size: 14px;font-weight: bold">门店编码</el-col>-->
            <!--                            <el-col :span="21" style="font-size: 14px;color: #4A4A4A">{{storeInfoAction.store_code}}</el-col>-->
            <!--                        </el-row>-->
            <el-row style="margin-top:24px">
              <el-col :span="3" style="font-size: 14px;font-weight: bold">类别</el-col>
              <el-col :span="21" style="font-size: 14px;color: #4A4A4A">{{ storeInfoAction.store_type_name }}</el-col>
            </el-row>
            <el-row style="margin-top:24px">
              <el-col :span="3" style="font-size: 14px;font-weight: bold">级别</el-col>
              <el-col :span="21" style="font-size: 14px;color: #4A4A4A">{{ storeInfoAction.retailstore_grade_name }}
              </el-col>
            </el-row>
            <el-row style="margin-top:24px">
              <el-col :span="3" style="font-size: 14px;font-weight: bold">地址</el-col>
              <el-col :span="21" style="color: #4A4A4A;font-size: 14px">{{ storeInfoAction.address }}</el-col>
            </el-row>
            <el-row style="margin-top:24px">
              <el-col :span="3" style="font-size: 14px;font-weight: bold">联系电话</el-col>
              <el-col :span="21" style="font-size: 14px;color: #4A4A4A">{{ storeInfoAction.telephone }}</el-col>
            </el-row>
          </div>


          <div class="arraylist" style="margin-top: 56px;">

            <div>
                        <span style="color: #4A90E2;font-size: 16px;font-weight: bold">
                             店员列表
                        </span>
              <el-button size="mini" icon="el-icon-plus"
                         style="float: right;background-color: #4ec880;color: white;border: 1px solid #4ec880;margin-bottom: 4px;margin-top: -9px"
                         @click="tianjia">添加店员
              </el-button>
            </div>

            <el-row style="margin-top: 7px">
              <el-col style="border: 1px solid #dedede;width: 275px;height: 80px;margin-top: 15px;margin-right: 10px"
                      v-for="(item,index) in  ClerkList">
                                <span>
                                                <img src="../../assets/images/chat_header_image.png" alt=""
                                                     style="margin:9px 0 0 10px;width: 58px;height: 58px">
                                            </span>
                <span style="position: relative;top: -44px;left: 10px">
                                <span style="color: #4D586D;font-size: 15px">{{ item.clerk_name }}</span>
                                <span
                                    style="background-color:#ff9901;color: #ffffff;font-size: 11px;border-radius: 3px;padding:2px 7px;position: relative;top: -2px;"
                                    v-if="item.manager_name=='店长'">{{ item.manager_name }}</span>
                           </span>
                <span
                    style="color: #ff9901;float: right;padding: 10px 20px;cursor: pointer;font-weight: bold;font-size: 12px"
                    @click="bianji(item)">
                                编辑
                            </span>
                <div style="width: 190px;margin-top:-20px;float: right">
                  <img src="../../assets/images/tu5.png" alt="">
                  <span style="color: #B0B5B9;font-size: 13px;position: relative;top: -2px;">
                                    {{ item.mobile }}
                                </span>
                </div>
              </el-col>

            </el-row>


          </div>


        </el-main>
    </el-container>
    <el-container v-else-if="StoreList.length == 0" style="height: 100%">
      <div style="margin: auto">
        <img src="../../assets/images/691C8AAA4F3F3242DF42BB05FCAFB165.png" alt="">
      </div>
    </el-container>


    <el-dialog
        :visible.sync="dialogVisible"
        width="900px"
        id="DianClass1"
        :show-close="false"
        style="vertical-align: center;: #FFF9F3">
      <div style="margin-top: -40px">
        <el-row style="padding-bottom: 10px;">
          <el-col :span="12">
            <div style="color: #3998F7;padding-top: 8px;font-size: 20px">店员详情
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="primary" size="small" @click="baocun4">
                保存
              </el-button>
              <el-button type="danger" size="small" @click="assistant">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
        <el-tabs v-model="activeName2">
          <el-tab-pane label="基本信息" name="first">
            <div class="DianClass" style="margin-top: 20px;">
              <el-form ref="clerkClass" :model="clerkClass" label-width="150px" hide-required-asterisk>
                <!--                        <el-row >-->
                <!--                            <el-col :span="12">-->
                <!--                                <el-form-item-->
                <!--                                        label="店员编码"-->
                <!--                                        prop="clerk_code"-->
                <!--                                        :rules="[-->
                <!--                                            { required: true, message: '店员编码不能为空'},-->
                <!--                                        ]"-->
                <!--                                >-->
                <!--                                    <el-input v-model="clerkClass.clerk_code" placeholder="请输入店员编码"></el-input>-->
                <!--                                </el-form-item>-->
                <!--                            </el-col>-->
                <!--                        </el-row>-->
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                        label="姓名"
                        prop="clerk_name" class="home_star"
                        :rules="[
                                            { required: true, message: '姓名不能为空'},
                                        ]"
                    >
                      <el-input v-model="clerkClass.clerk_name" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="性别">
                      <el-select v-model="clerkClass.gender" style="width:100%" placeholder="请选择" clearable>
                        <el-option label="男" value="M"></el-option>
                        <el-option label="女" value="F"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话">
                      <el-input v-model="clerkClass.mobile" placeholder="请输入联系电话"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="电子邮件">
                      <el-input v-model="clerkClass.email" placeholder="请输入电子邮箱"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="生日">
                      <el-date-picker
                          v-model="clerkClass.birthday"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="请选择出生日期"
                          style="width: 100%"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="爱好">
                      <el-input v-model="clerkClass.hobby" placeholder="请输入个人爱好"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="店长">
                      <el-switch
                          v-model="clerkClass.manager"
                          active-color="#13ce66"
                      >
                      </el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="在职">
                      <el-switch
                          v-model="clerkClass.status"
                          active-color="#13ce66"
                      >
                      </el-switch>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="items.group_name" :name="items.name" v-for="(items,j) in extendedInfo1">
            <div class="subjectList" style="margin-top: 20px;">
              <el-form :ref="'assistantList'+j" label-width="30%" v-for="(item,j) in items.fieldArray" :model="item"
                       :key="item.field_id" hide-required-asterisk>
                <el-col span="24" v-if="item.input_type == 'TEXT'">
                  <el-form-item :label="item.label"
                                prop="field_value" :class="{home_star:item.mandatory == 'T'}"
                                :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                  >
                    <el-input v-model="item.field_value" placeholder="请输入文本"
                              :disabled="item.readonly == 'T'"></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                  <el-form-item :label="item.label" :class="{home_star:item.mandatory == 'T'}"
                                prop="field_value"
                                :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                  >
                    <el-input v-model="item.field_value" placeholder="请输入数字" type="number"
                              :disabled="item.readonly == 'T'"></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'DATE'">
                  <el-form-item :label="item.label" :class="{home_star:item.mandatory == 'T'}"
                                prop="field_value"
                                :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                  >
                    <el-date-picker
                        v-model="item.field_value"
                        type="date"
                        placeholder="选择日期时间"
                        style="width: 100%"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        :disabled="item.readonly == 'T'">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                  <el-form-item :label="item.label"

                  >
                    <el-switch
                        v-model="item.field_value"
                        active-color="#13ce66"
                        active-value="T"
                        inactive-value="F"
                        :disabled="item.readonly == 'T'"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'LIST'">
                  <el-form-item :label="item.label" :class="{home_star:item.mandatory == 'T'}"
                                prop="field_value"
                                :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                  >
                    <!--                                        <el-select v-model="item.field_value" :multiple="item.multiple == 'T'" placeholder="请选择" style="width: 100%" :disabled="item.readonly == 'T'">-->
                    <!--                                            <el-option-->
                    <!--                                                    v-for="item in item.listArray"-->
                    <!--                                                    :key="item.key"-->
                    <!--                                                    :label="item.value1"-->
                    <!--                                                    :value="item.key">-->
                    <!--                                            </el-option>-->
                    <!--                                        </el-select>-->
                    <el-cascader
                        v-model="item.field_value"
                        :options="item.listArray"
                        style="width: 100%"
                        filterable
                        :show-all-levels="false"
                        :disabled="item.readonly == 'T'"
                        :props="{ multiple: item.multiple == 'T' ? true:false,checkStrictly: true }"
                        clearable></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                  <el-form-item :label="item.label" :class="{home_star:item.mandatory == 'T'}"
                                prop="field_value"
                                :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                  >
                    <el-table
                        :data="item.field_value"
                        border
                        style="width: 100%">
                      <el-table-column
                          type="index"
                          label="序号"
                          width="50">
                      </el-table-column>
                      <el-table-column
                          prop="dept_name"
                          label="标准科室"
                          v-if="item.array_dept !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column
                          prop="product_name"
                          label="产品"
                          v-if="item.array_product !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column
                          prop="sku_name"
                          label="SKU"
                          v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column
                          prop="date_name"
                          label="日期"
                          v-if="item.array_date !== 'NONE' "
                      >
                      </el-table-column>
                      <el-table-column
                          prop="field_value"
                          label="数值"
                      >
                      </el-table-column>
                      <el-table-column
                          fixed="right"
                          label="操作"
                          width="80"
                          v-if="item.readonly == 'T' ? false:true"
                      >
                        <template slot-scope="scope">
                          <el-button @click="handleTableClick(scope.$index, scope.row,item)"
                                     style="background-color: rgb(255, 153, 1);border: 1px solid rgb(255, 153, 1);color: #fff"
                                     size="small">详情
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form-item>
                  <el-col :span="24" style="margin-bottom: 10px;" v-if="item.readonly == 'T' ? false:true">
                    <el-button size="small" icon="el-icon-plus"
                               style="float: left;margin-left: 30%;background-color:#6cc584;border: 1px solid #6cc584;color:#fff"
                               @click="addNewTable(item)">添加新数据
                    </el-button>
                  </el-col>
                  <el-col :span="24" v-if="item.isAddTable" id="addTableHcp"
                          style="margin-left: 30%;width:70%;background: #edf3fb;border: 1px solid #ecdfe6;margin-bottom:10px;border-radius: 10px;">
                    <el-col :span="14">
                      <el-form ref="addTableHcp" :model="item.addTableList" style="margin-top:20px"
                               hide-required-asterisk>
                        <el-form-item label="标准科室" v-if="item.array_dept !== 'NONE'" prop="dept_id" class="home_star"
                                      :rules="{ required: true, message: '标准科室不能为空'}">
                          <el-select v-model="item.addTableList.dept_id" placeholder="请选择标准科室"
                                     style="width: 70%;float: right" clearable>
                            <el-option
                                v-for="item in administrativeList"
                                :key="item.key"
                                :label="item.value1"
                                :value="item.key">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="产品" v-if="item.array_product !== 'NONE'" prop="product_id"
                                      class="home_star"
                                      :rules="{ required: true, message: '产品不能为空'}">
                          <el-select v-model="item.addTableList.product_id" placeholder="请选择产品"
                                     style="width: 70%;float: right" @change="getSkuList(item)" clearable>
                            <el-option
                                v-for="item in productList"
                                :key="item.key"
                                :label="item.value1"
                                :value="item.key">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="SKU" v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                                      prop="sku_id" class="home_star"
                                      :rules="{ required: true, message: 'SKU不能为空'}">
                          <el-select v-model="item.addTableList.sku_id" placeholder="请选择SKU"
                                     style="width: 70%;float: right" clearable>
                            <el-option
                                v-for="item in SkuList"
                                :key="item.key"
                                :label="item.value1"
                                :value="item.key">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="日期" v-if="item.array_date !== 'NONE' && item.array_date !== ''"
                                      prop="info_date" :class="{home_star:true}"
                                      :rules="{ required: true, message: '日期不能为空'}">
                          <el-date-picker
                              v-model="item.addTableList.info_date"
                              type="year"
                              style="width: 70%;float: right"
                              format="yyyy年"
                              value-format="yyyy年"
                              placeholder="选择年"
                              v-if="item.array_date == 'YEAR'"
                          >
                          </el-date-picker>
                          <quarter v-if="item.array_date == 'QUARTER'" @child-event="parentEvent"
                                   :defaultValue="item.addTableList.info_date" :getValue="getQuarterValue"
                                   style="width: 70%;float: right"></quarter>
                          <el-date-picker
                              v-model="item.addTableList.info_date"
                              type="month"
                              style="width: 70%;float: right"
                              format="yyyy年MM月"
                              value-format="yyyy年MM月"
                              placeholder="选择月"
                              v-if="item.array_date == 'MONTH'"
                          >
                          </el-date-picker>
                          <monthComponent v-if="item.array_date == 'WEEK'" @week-event="parentWeekEvent"
                                          :defaultValue="item.addTableList.info_date" :getValue="getWeekValue"
                                          style="width: 70%;float: right"></monthComponent>
                          <el-date-picker
                              v-model="item.addTableList.info_date"
                              type="date"
                              placeholder="选择日期"
                              style="width: 70%;float: right"
                              format="yyyy年MM月dd日"
                              value-format="yyyy年MM月dd日"
                              v-if="item.array_date == 'DAY'"
                          >
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="数值" prop="field_value" class="home_star"
                                      :rules="{ required: true, message: '数值不能为空'}">
                          <el-input v-model="item.addTableList.field_value" placeholder="请输入数值"
                                    style="width: 70%;float: right"></el-input>
                        </el-form-item>
                      </el-form>

                    </el-col>
                    <el-col :span="10">
                      <el-col style="margin-top:20px;">
                        <el-button size="small"
                                   style="float: left;margin-left:40px;background-color:#588ede;border: 1px solid #588ede;color:#fff"
                                   @click="addTableDataHcp(item)">保存
                        </el-button>
                        <el-button
                            style="float: left;margin-left: 20px;background-color:#e87570;border: 1px solid #e87570;color:#fff"
                            @click="delateTableData(item)" v-if="delateFalse" size="small">删除
                        </el-button>
                        <el-button size="small"
                                   style="float: left;margin-left: 20px;background-color:#e87570;border: 1px solid #e87570;color:#fff"
                                   @click="cancelTableData(item)">取消
                        </el-button>
                      </el-col>

                    </el-col>
                  </el-col>
                </el-col>
                <el-col span="24" v-else>
                  <el-form-item :label="item.label" :class="{home_star:item.mandatory == 'T'}"
                                prop="field_value"
                                :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                  >
                    <el-input :rows="3" v-model="item.field_value" placeholder="请输入备注信息" type="textarea"
                              :disabled="item.readonly == 'T'"></el-input>
                  </el-form-item>
                </el-col>

              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>

    <el-dialog
        :visible.sync="dialogVisible2"
        width="900px"
        :show-close="false"
        style="vertical-align: center;margin-top: -70px">
      <div style="margin-top: -40px">
        <el-row style="padding-bottom: 10px;">
          <el-col :span="12">
            <div style="color: #3998F7;padding-top: 8px;font-size: 20px">门店详情
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="primary" size="small" @click="baocun6" v-show="this.activeName1=='third' ? false:true">
                保存
              </el-button>
              <el-button type="danger" size="small" @click="guanbi2">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
        <el-tabs v-model="activeName1" @tab-click="handleClickTabs">
          <el-tab-pane label="基本信息" name="first">
            <div class="HcpClass" style="margin-top: 20px;">
              <el-form ref="storelist" :model="storelist" label-width="150px" :rules="rules" hide-required-asterisk>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="名称" prop="store_name" class="home_star"
                                  :rules="[{ required: true, message: '名称不能为空'}]">
                      <el-input v-model="storelist.store_name" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="编码" prop="store_code" class="home_star"
                                  :rules="[{ required: true, message: '编码不能为空'}]">
                      <el-input v-model="storelist.store_code" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="类别" prop="store_type" class="home_star"
                                  :rules="[{ required: true, message: '类别不能为空'}]">
                      <el-select v-model="storelist.store_type" style="width: 100%" @change="fangfa2" placeholder="  "
                                 disabled>
                        <el-option
                            v-for="item in TypeList"
                            :key="item.key"
                            :label="item.value1"
                            :value="item.key">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="级别">
                      <el-select v-model="storelist.retailstore_grade_name" placeholder="  " style="width:100%"
                                 disabled>
                        <el-option
                            v-for="item in GardeList"
                            :key="item.key"
                            :label="item.value1"
                            :value="item.key">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="省份" prop="province_id" class="home_star"
                                  :rules="[{ required: true, message: '省份不能为空'}]">
                      <el-select v-model="storelist.province_id" style="width: 100%" @change="fangfa" placeholder="  "
                                 disabled>
                        <el-option
                            v-for="item in data"
                            :key="item.province_id"
                            :label="item.province_name"
                            :value="item.province_id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="城市" prop="city_id" class="home_star"
                                  :rules="[{ required: true, message: '城市不能为空'}]">
                      <el-select v-model="storelist.city_id" style="width: 100%" placeholder="  " disabled>
                        <el-option
                            v-for="item in CityList"
                            :key="item.city_id"
                            :label="item.city_name"
                            :value="item.city_id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>


                <el-row>
                  <el-col :span="12">
                    <el-form-item label="所属医疗机构">
                      <el-select v-model="storelist.institution_id" placeholder="  " disabled style="width: 100%">
                        <el-option
                            v-for="item in institutionList"
                            :key="item.institution_id"
                            :label="item.institution_name"
                            :value="item.institution_id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="地址">
                      <el-input v-model="storelist.address" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="联系电话">
                      <el-input v-model="storelist.telephone" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="邮政编码">
                      <el-input v-model="storelist.postcode" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="官方网址">
                      <el-input v-model="storelist.website" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="所属经销商">

                      <el-select v-model="storelist.distributor_id" filterable disabled placeholder="  "
                                 style="width: 100%">
                        <el-option
                            v-for="item in distributorList"
                            :key="item.distributor_id"
                            :label="item.distributor_name"
                            :value="item.distributor_id">
                        </el-option>
                      </el-select>

                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">

                    <el-form-item label="客户级别" v-if="storelist.segment_name!==''">
                      <span style="color: #4A90E2" v-model="storelist.segment_name">{{ storelist.segment_name }}</span>
                    </el-form-item>
                    <el-form-item label="客户级别" v-else-if="storelist.segment_name==''">
                      <span style="">暂无</span>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="目标客户">
                      <el-switch
                          v-model="storelist.account_status"
                          disabled
                          active-color="#13ce66"
                      >
                      </el-switch>
                    </el-form-item>
                  </el-col>
                </el-row>


              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="items.group_name" :name="items.name" v-for="(items,j) in extendedInfo">
            <div class="subjectList" style="margin-top: 20px;">
              <el-form :ref="'list'+j" label-width="30%" v-for="(item,j) in items.fieldArray" :model="item"
                       :key="item.field_id" hide-required-asterisk>
                <el-col span="24" v-if="item.input_type == 'TEXT'">
                  <el-form-item :label="item.label" :class="{home_star:item.mandatory == 'T'}"
                                prop="field_value"
                                :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                  >
                    <el-input v-model="item.field_value" placeholder="请输入文本"
                              :disabled="item.readonly == 'T'"></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                  <el-form-item :label="item.label" :class="{home_star:item.mandatory == 'T'}"
                                prop="field_value"
                                :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                  >
                    <el-input v-model="item.field_value" placeholder="请输入数字" type="number"
                              :disabled="item.readonly == 'T'"></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'DATE'">
                  <el-form-item :label="item.label" :class="{home_star:item.mandatory == 'T'}"
                                prop="field_value"
                                :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                  >
                    <el-date-picker
                        v-model="item.field_value"
                        type="date"
                        placeholder="选择日期时间"
                        style="width: 100%"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        :disabled="item.readonly == 'T'">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                  <el-form-item :label="item.label"

                  >
                    <el-switch
                        v-model="item.field_value"
                        active-color="#13ce66"
                        active-value="T"
                        inactive-value="F"
                        :disabled="item.readonly == 'T'"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'LIST'">
                  <el-form-item :label="item.label" :class="{home_star:item.mandatory == 'T'}"
                                prop="field_value"
                                :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                  >
                    <!--                                        <el-select v-model="item.field_value" :multiple="item.multiple == 'T'" placeholder="请选择" style="width: 100%" :disabled="item.readonly == 'T'">-->
                    <!--                                            <el-option-->
                    <!--                                                    v-for="item in item.listArray"-->
                    <!--                                                    :key="item.key"-->
                    <!--                                                    :label="item.value1"-->
                    <!--                                                    :value="item.key">-->
                    <!--                                            </el-option>-->
                    <!--                                        </el-select>-->
                    <el-cascader
                        v-model="item.field_value"
                        :options="item.listArray"
                        style="width: 100%"
                        filterable
                        :show-all-levels="false"
                        :disabled="item.readonly == 'T'"
                        :props="{ multiple: item.multiple == 'T' ? true:false,checkStrictly: true }"
                        clearable></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                  <el-form-item :label="item.label" :class="{home_star:item.mandatory == 'T'}"
                                prop="field_value"
                                :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                  >
                    <el-table
                        :data="item.field_value"
                        border
                        style="width: 100%">
                      <el-table-column
                          type="index"
                          label="序号"
                          width="50">
                      </el-table-column>
                      <el-table-column
                          prop="dept_name"
                          label="标准科室"
                          v-if="item.array_dept !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column
                          prop="product_name"
                          label="产品"
                          v-if="item.array_product !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column
                          prop="sku_name"
                          label="SKU"
                          v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column
                          prop="date_name"
                          label="日期"
                          v-if="item.array_date !== 'NONE' "
                      >
                      </el-table-column>
                      <el-table-column
                          prop="field_value"
                          label="数值"
                      >
                      </el-table-column>
                      <el-table-column
                          fixed="right"
                          label="操作"
                          width="80"
                          v-if="item.readonly == 'T' ? false:true"
                      >
                        <template slot-scope="scope">
                          <el-button @click="handleTableClick(scope.$index, scope.row,item)"
                                     style="background-color: rgb(255, 153, 1);border: 1px solid rgb(255, 153, 1);color: #fff"
                                     size="small">详情
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form-item>
                  <el-col :span="24" style="margin-bottom: 10px;" v-if="item.readonly == 'T' ? false:true">
                    <el-button size="small" icon="el-icon-plus"
                               style="float: left;margin-left: 30%;background-color:#6cc584;border: 1px solid #6cc584;color:#fff"
                               @click="addNewTable(item)">添加新数据
                    </el-button>
                  </el-col>
                  <el-col :span="24" v-if="item.isAddTable" id="addTable"
                          style="margin-left:30%;width:70%;background: #edf3fb;border: 1px solid #ecdfe6;margin-bottom:10px;border-radius: 10px;">
                    <el-col :span="14">
                      <el-form ref="addTable" :model="item.addTableList" style="margin-top:20px" hide-required-asterisk>
                        <el-form-item label="标准科室" v-if="item.array_dept !== 'NONE'" prop="dept_id" class="home_star"
                                      :rules="{ required: true, message: '标准科室不能为空'}">
                          <el-select v-model="item.addTableList.dept_id" placeholder="请选择标准科室"
                                     style="width: 70%;float: right" clearable>
                            <el-option
                                v-for="item in administrativeList"
                                :key="item.key"
                                :label="item.value1"
                                :value="item.key">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="产品" v-if="item.array_product !== 'NONE'" prop="product_id"
                                      class="home_star"
                                      :rules="{ required: true, message: '产品不能为空'}">
                          <el-select v-model="item.addTableList.product_id" placeholder="请选择产品"
                                     style="width: 70%;float: right" @change="getSkuList(item)" clearable>
                            <el-option
                                v-for="item in productList"
                                :key="item.key"
                                :label="item.value1"
                                :value="item.key">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="SKU" v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                                      prop="sku_id" class="home_star"
                                      :rules="{ required: true, message: 'SKU不能为空'}">
                          <el-select v-model="item.addTableList.sku_id" placeholder="请选择SKU"
                                     style="width: 70%;float: right" clearable>
                            <el-option
                                v-for="item in SkuList"
                                :key="item.key"
                                :label="item.value1"
                                :value="item.key">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="日期" v-if="item.array_date !== 'NONE' && item.array_date !== ''"
                                      prop="info_date" :class="{home_star:true}"
                                      :rules="{ required: true, message: '日期不能为空'}">
                          <el-date-picker
                              v-model="item.addTableList.info_date"
                              type="year"
                              style="width: 70%;float: right"
                              format="yyyy年"
                              value-format="yyyy年"
                              placeholder="选择年"
                              v-if="item.array_date == 'YEAR'"
                          >
                          </el-date-picker>
                          <quarter v-if="item.array_date == 'QUARTER'" @child-event="parentEvent"
                                   :defaultValue="item.addTableList.info_date" :getValue="getQuarterValue"
                                   style="width: 70%;float: right"></quarter>
                          <el-date-picker
                              v-model="item.addTableList.info_date"
                              type="month"
                              style="width: 70%;float: right"
                              format="yyyy年MM月"
                              value-format="yyyy年MM月"
                              placeholder="选择月"
                              v-if="item.array_date == 'MONTH'"
                          >
                          </el-date-picker>
                          <monthComponent v-if="item.array_date == 'WEEK'" @week-event="parentWeekEvent"
                                          :defaultValue="item.addTableList.info_date" :getValue="getWeekValue"
                                          style="width: 70%;float: right"></monthComponent>
                          <el-date-picker
                              v-model="item.addTableList.info_date"
                              type="date"
                              placeholder="选择日期"
                              style="width: 70%;float: right"
                              format="yyyy年MM月dd日"
                              value-format="yyyy年MM月dd日"
                              v-if="item.array_date == 'DAY'"
                          >
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="数值" prop="field_value" class="home_star"
                                      :rules="{ required: true, message: '数值不能为空'}">
                          <el-input v-model="item.addTableList.field_value" placeholder="请输入数值"
                                    style="width: 70%;float: right"></el-input>
                        </el-form-item>
                      </el-form>

                    </el-col>
                    <el-col :span="10">
                      <el-col style="margin-top:20px;">
                        <el-button size="small"
                                   style="float: left;margin-left: 40px;background-color:#588ede;border: 1px solid #588ede;color:#fff"
                                   @click="addTableData(item)">保存
                        </el-button>
                        <el-button
                            style="float: left;margin-left: 20px;background-color:#e87570;border: 1px solid #e87570;color:#fff"
                            @click="delateTableData(item)" v-if="delateFalse" size="small">删除
                        </el-button>
                        <el-button size="small"
                                   style="float: left;margin-left: 20px;background-color:#e87570;border: 1px solid #e87570;color:#fff"
                                   @click="cancelTableData(item)">取消
                        </el-button>
                      </el-col>

                    </el-col>
                  </el-col>
                </el-col>
                <el-col span="24" v-else>
                  <el-form-item :label="item.label" :class="{home_star:item.mandatory == 'T'}"
                                prop="field_value"
                                :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []"
                  >
                    <el-input :rows="3" v-model="item.field_value" placeholder="请输入备注信息" type="textarea"
                              :disabled="item.readonly == 'T'"></el-input>
                  </el-form-item>
                </el-col>

              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="变更历史" name="third">
            <el-form ref="storelist" :model="storelist" label-width="150px" :rules="rules">
              <el-row style="margin-top: 20px">
                <el-table border :data="listData" stripe style="width: 100%" header-cell-class-name="headerStyle"
                          :default-sort="{prop: 'date', order: 'descending'}">
                  <el-table-column type="index" :index="1" label="序号" style="font-size: 20px;color: #585757"
                                   width="65"></el-table-column>
                  <el-table-column
                      prop="segment_name"
                      label="客户级别"
                      min-width="100px"
                      sortable
                  >
                    <template slot-scope="scope">

                      <div v-if="scope.row.old_segment_name !== scope.row.segment_name">
                        <span style="margin-left: 5px; color: #4A90E2">{{ scope.row.old_segment_name }}</span>
                        <span style="color: #4A90E2"> -> </span>
                        <span style="color: #4A90E2">{{ scope.row.segment_name }}</span>
                      </div>
                      <div v-else="scope.row.old_segment_name == scope.row.segment_name">
                        <span style="margin-left: 5px; color: #4A90E2">{{ scope.row.old_segment_name }}</span><span
                          style="color: #4A90E2">(无变化)</span>
                      </div>

                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="status"
                      label="目标客户"
                      min-width="100px"
                      sortable
                  >
                    <template slot-scope="scope">

                      <div v-if="scope.row.account_status == scope.row.old_account_status">
                        <span style="color: #4A90E2" v-if="scope.row.old_account_status=='ACTIVE'">是</span>
                        <span style="color: #4A90E2" v-else="scope.row.old_account_status=='INACTIVE'">否</span>
                        <span style="color: #4A90E2">(无变化)</span>
                      </div>

                      <div v-else="scope.row.account_status!== scope.row.old_account_status">
                        <span style="margin-left: 5px; color: #4A90E2"
                              v-if="scope.row.old_account_status=='ACTIVE'">是</span>
                        <span style="margin-left: 5px; color: #4A90E2"
                              v-else-if="scope.row.old_account_status=='INACTIVE'">否</span>
                        <span style="color: #4A90E2"> -> </span>
                        <span style="color: #4A90E2" v-if="scope.row.account_status=='ACTIVE'">是</span>
                        <span style="color: #4A90E2" v-else-if="scope.row.account_status=='INACTIVE'">否</span>
                      </div>

                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="alias"
                      label="人员"
                      min-width="90px"
                      sortable>
                  </el-table-column>
                  <el-table-column
                      prop="created_date"
                      label="变更提交日期"
                      min-width="158px"
                      sortable>
                  </el-table-column>
                  <el-table-column
                      prop="effective_date"
                      label="计划生效日期"
                      min-width="158px"
                      sortable>
                  </el-table-column>

                  <el-table-column
                      prop="status_name"
                      label="状态"
                      min-width="100%"
                      sortable>
                  </el-table-column>
                  <el-table-column label="操作" width="72px" style="color: #4A90E2">

                    <template slot-scope="scope">
                      <el-button v-if="scope.row.status == 'ACTIVE'"
                                 type="warning"
                                 size="mini"
                                 style="margin-right: 10px;float: left;background-color: #ff9901;border: #ff9901 1px solid;"
                                 @click="addlist2(scope.row)"
                      >编辑
                      </el-button>

                      <el-button v-else-if="scope.row.status != 'ACTIVE'"
                                 type="warning"
                                 size="mini"
                                 style="margin-right: 10px;float: left;background-color: #ff9901;border: #ff9901 1px solid;"
                                 @click="addlist3(scope.row)"
                      >详情
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>

              <el-row style="margin-top: 30px">
                <el-col :span="12">
                  <div style="color: #3998F7;padding-top: 8px;font-size: 26px">填写变更申请
                  </div>
                </el-col>
                <el-col :span="12" align="right">
                  <el-button icon="el-icon-plus" type="success" @click="addlist" :disabled="isDisabled">填写变更申请
                  </el-button>
                </el-col>
              </el-row>

              <div id="div1">
                <div style="margin-top: 10px; border: 1px solid #ededed;background-color: #ecf3fc;border-radius: 5px">
                  <el-row>
                    <el-col :span="9" style="padding-top: 23px">
                      <el-form-item label="客户级别">
                        <el-select v-model="storelist.rank" placeholder="请选择客户级别" style="width: 100%" clearable>
                          <el-option
                              v-for="item in Category"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="9" style="padding-top: 23px">
                      <el-form-item label="目标客户">
                        <el-switch
                            v-model="storelist.value"
                            active-color="#13ce66"
                        >
                        </el-switch>
                      </el-form-item>
                    </el-col>

                    <el-col :span="6" align="right" style="margin-top: 26px;padding-right: 20px">
                      <el-button type="primary" size="small" @click="AccountDraft">
                        保存
                      </el-button>
                      <el-button type="danger" size="small" @click="closelist">
                        取消
                      </el-button>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="9" style="padding-top: -10px">
                      <el-form-item label="生效时间">
                        <el-select v-model="storelist.time" placeholder="请选择生效时间" style="width: 100%" clearable>
                          <el-option label="本月生效" value="D"></el-option>
                          <el-option label="次月生效" value="C"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="15">
                                       <span style="color: #ED3B3F;font-size: 12px;margin-left: 10px;line-height: 37px">
                                           注意：生效日期如选择“本月生效”，将直接影响本月相关的绩效考核结果
                                       </span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="20" style="padding-top: -10px">
                      <el-form-item label="变更原因">
                        <el-input type="textarea" :rows="2" placeholder="请输入变更原因" v-model="storelist.comments">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>

              <div id="div2">
                <div style="margin-top: 10px; border: 1px solid #ededed;background-color: #ecf3fc;border-radius: 5px">
                  <el-row>
                    <el-col :span="9" style="padding-top: 23px">
                      <el-form-item label="客户级别">
                        <el-select v-model="storelist.rank2" placeholder="请选择客户级别" style="width: 100%" clearable>
                          <el-option
                              v-for="item in Category"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="9" style="padding-top: 23px">
                      <el-form-item label="目标客户">
                        <el-switch
                            v-model="storelist.value2"
                            active-color="#13ce66"
                        >
                        </el-switch>
                      </el-form-item>
                    </el-col>

                    <el-col :span="6" align="right" style="margin-top: 26px;padding-right: 20px">
                      <el-button type="primary" size="small" @click="AccountDraft2">
                        保存
                      </el-button>
                      <el-button type="danger" size="small" @click="closelist2">
                        取消
                      </el-button>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="9" style="padding-top: -10px">
                      <el-form-item label="生效时间">
                        <el-select v-model="storelist.time2" placeholder="请选择生效时间" style="width: 100%" clearable>
                          <el-option label="本月生效" value="D"></el-option>
                          <el-option label="次月生效" value="C"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="15">
                                       <span style="color: #ED3B3F;font-size: 12px;margin-left: 10px;line-height: 37px">
                                           注意：生效日期如选择“本月生效”，将直接影响本月相关的绩效考核结果
                                       </span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="20" style="padding-top: -10px">
                      <el-form-item label="变更原因">
                        <el-input type="textarea" :rows="2" placeholder="请输入变更原因" v-model="storelist.comments2">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                </div>
              </div>

              <div id="div3">
                <div style="margin-top: 10px; border: 1px solid #ededed;background-color: #ecf3fc;border-radius: 5px">
                  <el-row>
                    <el-col :span="9" style="padding-top: 23px">
                      <el-form-item label="客户级别">
                        <el-select v-model="storelist.rank3" placeholder="请选择客户级别" style="width: 100%" disabled>
                          <el-option
                              v-for="item in Category"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="9" style="padding-top: 23px">
                      <el-form-item label="目标客户">
                        <el-switch
                            v-model="storelist.value3"
                            active-color="#13ce66"
                            disabled
                        >
                        </el-switch>
                      </el-form-item>
                    </el-col>

                    <el-col :span="6" align="right" style="margin-top: 26px;padding-right: 20px">
                      <el-button type="danger" size="small" @click="closelist3">
                        取消
                      </el-button>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="9" style="padding-top: -10px">
                      <el-form-item label="生效时间">
                        <el-select v-model="storelist.time3" placeholder="请选择生效时间" style="width: 100%" disabled>
                          <el-option label="本月生效" value="D"></el-option>
                          <el-option label="次月生效" value="C"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="20" style="padding-top: -10px">
                      <el-form-item label="变更原因">
                        <el-input type="textarea" :rows="2" placeholder="请输入变更原因" v-model="storelist.comments3"
                                  disabled>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>


            </el-form>
          </el-tab-pane>
        </el-tabs>


      </div>
    </el-dialog>

    <el-dialog
        :visible.sync="dialogVisible3"
        width="600px"
        :show-close="false"
        style="vertical-align: center;: #FFF9F3">
      <div style="margin-top: -40px">
        <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
          <el-col :span="12">
            <div style="color: #3998F7;padding-top: 8px;font-size: 20px">添加店员
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="primary" size="small" @click="baocun5">
                保存
              </el-button>
              <el-button type="danger" size="small" @click="guanbi">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
        <div class="DianClass" style="margin-top: 20px;">
          <el-form ref="clerkadd" :model="clerkadd" label-width="150px" hide-required-asterisk>
            <el-row>
              <el-col :span="22">
                <el-form-item
                    label="姓名"
                    prop="clerk_name" class="home_star"
                    :rules="[
                                          { required: true, message: '姓名不能为空'},
                                        ]"
                >
                  <el-input v-model="clerkadd.clerk_name" placeholder="请输入姓名"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!--                        <el-row >-->
            <!--                            <el-col :span="22" >-->
            <!--                                <el-form-item-->
            <!--                                        label="店员编码"-->
            <!--                                        prop="clerk_code"-->
            <!--                                        :rules="[-->
            <!--                                          { required: true, message: '店员编码不能为空'},-->
            <!--                                        ]"-->
            <!--                                >-->
            <!--                                    <el-input v-model="clerkadd.clerk_code" placeholder="请输入店员编码"></el-input>-->
            <!--                                </el-form-item>-->
            <!--                            </el-col>-->
            <!--                        </el-row>-->

            <el-row>
              <el-col :span="22">
                <el-form-item label="性别">
                  <el-select v-model="clerkadd.gender" style="width:100%" placeholder="请选择" clearable>
                    <el-option label="男" value="M"></el-option>
                    <el-option label="女" value="F"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>


            <el-row>
              <el-col :span="22">
                <el-form-item label="联系电话">
                  <el-input v-model="clerkadd.mobile" placeholder="请输入联系电话"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="22">
                <el-form-item label="电子邮件">
                  <el-input v-model="clerkadd.email" placeholder="请输入电子邮箱"></el-input>
                </el-form-item>
              </el-col>
            </el-row>


            <el-row>
              <el-col :span="22">
                <el-form-item label="生日">
                  <el-date-picker
                      v-model="clerkadd.birthday"
                      type="date"
                      placeholder="请选择出生日期"
                      style="width: 100%"
                      value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>


            <el-row>
              <el-col :span="22">
                <el-form-item label="爱好">
                  <el-input v-model="clerkadd.hobby" placeholder="请输入个人爱好"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="22">
                <el-form-item label="店长">
                  <el-switch
                      v-model="clerkadd.manager"
                      active-color="#13ce66"
                  >
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="22">
                <el-form-item label="在职">
                  <el-switch
                      v-model="clerkadd.status"
                      active-color="#13ce66"
                  >
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </el-dialog>


  </div>

</template>


<script>
// import TreeNode from './components/treeNode'
import http from '../../APIService/http'
import quarter from '../../components/quarter'
import monthComponent from '../../components/monthComponent'
import {bus} from '../../router/index.js'
import ImgUrl_n_red from '../../assets/images/folder_icon.png'
import ElForm from "../../../node_modules/element-ui/packages/form/src/form.vue";
import {AMapManager} from "vue-amap"
import {Message} from "element-ui";
import inputSelect from '../calendar/components/components/inputSelect.vue'
import imgUrl from '../../assets/images/mark_0.png'

let amapManager = new AMapManager();
export default {
  data() {
    let self = this;
    return {
      page:1,
      addTableList: {},
      delateFalse: false,
      tabIndex: 1,
      isAddTable: false,
      tableData: [],

      administrativeList: [],
      productList: [],
      SkuList: [],
      QUARTER: '',
      WEEK: '',
      isfalse: false,
      activeName1: 'first',
      activeName2: 'first',
      extendedInfo: [],
      extendedInfo1: [],
      centers: [],
      marginValue1: '',
      widthLocation: '',
      locationInfo: [],
      mydiv1: 0,
      name: '',
      hospitalInstitution_id: '',
      jinyong: false,
      rules: {
        store_name: [
          {required: true, message: '请输入机构名称'},
        ],
        store_code: [
          {required: true, message: '请输入机构编码'},
        ],
        store_type: [
          {required: true, message: '请输入类别'},
        ],
        province_id: [
          {required: true, message: '请输入选择省份'},
        ],
        city_id: [
          {required: true, message: '请输入选择机城市'},
        ],
      },
      UserList: [],
      storeInfoAction: [],
      mydiv: 0,
      institutionList: [],
      isDisabled: false,
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      activeName: 'first',
      icon_forder: ImgUrl_n_red,
      loading: false,
      form: {
        people: ''
      },

      showAmapDialog: false,
      amapManager,
      zoom: 15,
      center: [116.46, 39.92],
      markers: [
        {
          position: [116.46, 39.92],
          events: {
            click: () => {

              if (this.texts[0].name) {
                this.texts[0].name = ''
              } else {

                let name = "名称：" + self.storeInfoObj.store_name
                let address = "地址：" + self.storeInfoObj.address

                this.texts[0].name = "<span style='font-size: 14px;margin: 5px'>" + name + "</span>" + "<br/>" +
                    "<span style='font-size: 14px;margin: 5px'>" + address + "</span>" + "<br/>"

                let userObj = this.$store.getters.getUser
                if (userObj.role === 'admin') {
                  this.texts[0].name = this.texts[0].name +
                      "<span style='color: #FF9901;font-size: 14px;margin: 5px;float: right;cursor:pointer'>编辑坐标</span>"
                }

              }

            }
          },
          visible: true,

          template: '1'
        }
      ],
      edit_markers:
          {
            position: [],
            events: {
              dragend: (e) => {//拖拽结束

                this.edit_markers.position = [e.lnglat.lng, e.lnglat.lat];
              }
            },
            visible: true,
          },
      texts: [
        {
          position: [116.46, 39.92],
          name: '',
          offset: [0, -65],
          events: {
            click: () => {

              let userObj = this.$store.getters.getUser

              if (this.texts[0].name && userObj.role === 'admin') {
                self.showAmapDialog = true
              }

            }
          }
        }
      ],
      plugin: [{
        pName: 'ToolBar',
        position: 'RB',
        locate: false,
        events: {
          init(instance) {

          }
        }
      }],
      storelist: {
        account_id: "",
        account_status: "",
        segment_name: "",
        segment_id: "",
        tenant_id: "",
        store_id: "",
        store_name: "",
        store_code: '',
        store_type_name: "",
        store_type: "",
        retailstore_grade_name: '',
        retailstore_grade: "",
        province_id: "",
        province_name: "",
        city_id: "",
        status: "",
        city_name: "",
        address: "",
        telephone: "",
        postcode: "",
        website: "",
        location_id: "",
        lat: 0,
        lng: 0,
        alias: "",
        AccountArray: [],
        canAdd: "T",
        value: true,
        time: 'C',
        rank: '',
        rank2: '',
        time2: '',
        value2: true,
        rank3: '',
        time3: '',
        value3: '',
        comments: '',
        comments2: '',
        comments3: '',
      },
      clerkadd: {
        tenant_id: "",
        retailstore_id: "",
        clerk_id: "",
        clerk_name: "",
        gender_name: "",
        manager_name: "",
        gender: "",
        mobile: "",
        email: "",
        birthday: "",
        hobby: "",
        manager: false,
        status: true,
        status_name: "",
        clerk_code: ''
      },

      clerkClass: {
        clerk_code: '',
        tenant_id: "",
        retailstore_id: "",
        clerk_id: "",
        clerk_name: "",
        gender_name: "",
        manager_name: "",
        gender: "",
        mobile: "",
        email: "",
        birthday: "",
        hobby: "",
        manager: "",
        status: "",
        status_name: ""
      },
      listData: [],
      StoreList: [],
      retailstore_id: '',
      ClerkList: [],
      GardeList: [],
      TypeList: [],
      data: [],
      CityList: [],
      Category: [],
      account_id: '',
      role: '',
      territory_id: '',
      store_code: '',
      options: [],
      searchType: '所有下属',
      userIds: [],
      user_id: '',
      clientObj: {},
      searchTerritory_id:'',
    }
  },
  mounted() {


  },
  components: {
    inputSelect,
    quarter,
    monthComponent
  },
  async created() {
    this.role = this.$store.getters.getUser.role
    this.clientObj = this.$store.getters.getClient
    this.form.people = this.$route.query.user_id
    this.searchType = this.$route.query.searchType
    this.userIds = this.$route.query.userIds
    this.searchTerritory_id = this.GLOBAL.selectPeople_territoryId
    // console.log(this.searchType)
    if (this.role == 'staff') {
      this.jinyong = true

      this.userIds = []
      this.userIds.push(this.$store.getters.getUser.user_id)
      this.searchType = "多选人员"
      this.name = this.$store.getters.getUser.alias

    } else {
      this.jinyong = false
    }


    if (this.form.people == null) {
      this.form.people = ''
    }
    if (this.form.people == undefined) {
      this.form.people = ''
    }

    this.getRetailStoreList()
    this.getOuUserList()
    this.getProvinceList()
    this.getRetailstoreTypeList()
//            this.getRetailstoreGardeList()
    this.getDictionaryListByCategory()

  },
  computed: {},
  methods: {
    load(){
      this.page++
      this.getRetailStoreList()
    },
    getAdministrativeList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        category: 'STANDARD_DEPT'
      }
      http.post('/wapi/Institution/getAdministrativeList', data).then(res => {
        if (res.success) {
          this.administrativeList = res.data
        }
      })

    },
    getProductList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      }
      http.post('/wapi/Institution/getProductList', data).then(res => {
        if (res.success) {
          this.productList = res.data
        }
      })

    },
    getSkuList(item) {
      let product_id = ''
      if (item instanceof Object) {
        product_id = item.addTableList.product_id
        item.addTableList.sku_id = ''
        item.addTableList.sku_name = ''
      } else {
        product_id = item
      }

      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        product_id: product_id
      }
      http.post('/wapi/Institution/getSkuList', data).then(res => {
        if (res.success) {
          this.SkuList = res.data
        }
      })

    },
    changeQUARTER(item) {
      this.QUARTER = ''
      var arr = item.split('-')
      if (arr[1] < 4) {
        this.QUARTER = arr[0] + 'Q1'
      } else if (arr[1] > 3 && arr[1] < 7) {
        this.QUARTER = arr[0] + 'Q2'
      } else if (arr[1] > 6 && arr[1] < 9) {
        this.QUARTER = arr[0] + 'Q3'
      } else {
        this.QUARTER = arr[0] + 'Q4'
      }

      console.log(item, this.QUARTER)

    },
    changeWEEK(item) {
      this.WEEK = ''
      var arr = item.split('-')
      if (arr[2] < 8) {
        this.WEEK = arr[0] + arr[1] + 'W1'
      } else if (arr[2] > 7 && arr[2] < 15) {
        this.WEEK = arr[0] + arr[1] + 'W2'
      } else if (arr[2] > 14 && arr[2] < 22) {
        this.WEEK = arr[0] + arr[1] + 'W3'
      } else {
        this.WEEK = arr[0] + arr[1] + 'W4'
      }
      console.log(item, this.WEEK)
    },
    getUuid() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      return uuid

    },
    delateTableData(item) {
      for (let i = 0; i < item.field_value.length; i++) {
        if (item.addTableList.id == item.field_value[i].id) {
          item.field_value.splice(i, 1)
          item.isAddTable = false
          this.$forceUpdate()
        }
      }
    },
    addNewTable(item) {
      this.delateFalse = false
      item.isAddTable = true
      item.addTableList = {
        id: '',
        dept_id: '',
        dept_name: '',
        product_id: '',
        product_name: '',
        sku_id: '',
        sku_name: '',
        info_date: '',
        date_name: '',
        field_value: '',
      }
      this.addTableList = {}
      this.addTableList = item.addTableList
      this.$forceUpdate()
    },
    addTableData(item) {

      this.$refs["addTable"][0].validate(valid => {
        if (!valid) {
          return false
        } else {

          if (this.QUARTER) {
            item.addTableList.info_date = this.QUARTER
            let arr = this.QUARTER.split('Q')
            let year = arr[0].slice(0, 4)
            item.addTableList.date_name = `${year}年第${arr[1]}季度`
          }
          if (this.WEEK) {
            item.addTableList.info_date = this.WEEK
            let arr = this.WEEK.split('W')
            let year = arr[0].slice(0, 4)
            let month = arr[0].slice(4)
            item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`

          }

          if (item.addTableList.id) {//编辑
            for (let i = 0; i < item.field_value.length; i++) {
              if (item.addTableList.id == item.field_value[i].id) {
                item.field_value[i].dept_id = item.addTableList.dept_id
                if (item.addTableList.dept_id) {
                  for (let j = 0; j < this.administrativeList.length; j++) {
                    if (item.addTableList.dept_id == this.administrativeList[j].key) {
                      item.addTableList.dept_name = this.administrativeList[j].value1
                      break
                    }
                  }
                }
                item.field_value[i].dept_name = item.addTableList.dept_name
                item.field_value[i].product_id = item.addTableList.product_id
                if (item.addTableList.product_id) {
                  for (let j = 0; j < this.productList.length; j++) {
                    if (item.addTableList.product_id == this.productList[j].key) {
                      item.addTableList.product_name = this.productList[j].value1
                      break
                    }
                  }
                }
                item.field_value[i].product_name = item.addTableList.product_name
                item.field_value[i].sku_id = item.addTableList.sku_id
                if (item.addTableList.sku_id) {
                  for (let j = 0; j < this.SkuList.length; j++) {
                    if (item.addTableList.sku_id == this.SkuList[j].key) {
                      item.addTableList.sku_name = this.SkuList[j].value1
                      break
                    }
                  }
                }
                item.field_value[i].sku_name = item.addTableList.sku_name
                item.field_value[i].info_date = item.addTableList.info_date
                item.field_value[i].date_name = item.addTableList.date_name
                item.field_value[i].field_value = item.addTableList.field_value
              }
            }
          } else {//新增
            item.addTableList.id = this.getUuid()
            if (item.addTableList.dept_id) {
              for (let i = 0; i < this.administrativeList.length; i++) {
                if (item.addTableList.dept_id == this.administrativeList[i].key) {
                  item.addTableList.dept_name = this.administrativeList[i].value1
                }
              }
            }
            if (item.addTableList.product_id) {
              for (let i = 0; i < this.productList.length; i++) {
                if (item.addTableList.product_id == this.productList[i].key) {
                  item.addTableList.product_name = this.productList[i].value1
                }
              }
            }
            if (item.addTableList.sku_id) {
              for (let i = 0; i < this.SkuList.length; i++) {
                if (item.addTableList.sku_id == this.SkuList[i].key) {
                  item.addTableList.sku_name = this.SkuList[i].value1
                }
              }
            }
            if (this.QUARTER) {
              item.addTableList.info_date = this.QUARTER
              let arr = this.QUARTER.split('Q')
              let year = arr[0].slice(0, 4)
              item.addTableList.date_name = `${year}年第${arr[1]}季度`
            } else if (this.WEEK) {
              item.addTableList.info_date = this.WEEK
              let arr = this.WEEK.split('W')
              let year = arr[0].slice(0, 4)
              let month = arr[0].slice(4)
              item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`

            } else {
              item.addTableList.date_name = item.addTableList.info_date
            }
            item.field_value.push(item.addTableList)
          }

          item.isAddTable = false
          item.addTableList = {
            id: '',
            dept_id: '',
            dept_name: '',
            product_id: '',
            product_name: '',
            sku_id: '',
            sku_name: '',
            info_date: '',
            date_name: '',
            field_value: '',
          }
          this.$forceUpdate()

        }
      })

    },

    addTableDataHcp(item) {

      this.$refs["addTableHcp"][0].validate(valid => {
        if (!valid) {
          return false
        } else {

          if (this.QUARTER) {
            item.addTableList.info_date = this.QUARTER
            let arr = this.QUARTER.split('Q')
            let year = arr[0].slice(0, 4)
            item.addTableList.date_name = `${year}年第${arr[1]}季度`
          }
          if (this.WEEK) {
            item.addTableList.info_date = this.WEEK
            let arr = this.WEEK.split('W')
            let year = arr[0].slice(0, 4)
            let month = arr[0].slice(4)
            item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`

          }

          if (item.addTableList.id) {//编辑
            for (let i = 0; i < item.field_value.length; i++) {
              if (item.addTableList.id == item.field_value[i].id) {
                item.field_value[i].dept_id = item.addTableList.dept_id
                if (item.addTableList.dept_id) {
                  for (let j = 0; j < this.administrativeList.length; j++) {
                    if (item.addTableList.dept_id == this.administrativeList[j].key) {
                      item.addTableList.dept_name = this.administrativeList[j].value1
                      break
                    }
                  }
                }
                item.field_value[i].dept_name = item.addTableList.dept_name
                item.field_value[i].product_id = item.addTableList.product_id
                if (item.addTableList.product_id) {
                  for (let j = 0; j < this.productList.length; j++) {
                    if (item.addTableList.product_id == this.productList[j].key) {
                      item.addTableList.product_name = this.productList[j].value1
                      break
                    }
                  }
                }
                item.field_value[i].product_name = item.addTableList.product_name
                item.field_value[i].sku_id = item.addTableList.sku_id
                if (item.addTableList.sku_id) {
                  for (let j = 0; j < this.SkuList.length; j++) {
                    if (item.addTableList.sku_id == this.SkuList[j].key) {
                      item.addTableList.sku_name = this.SkuList[j].value1
                      break
                    }
                  }
                }
                item.field_value[i].sku_name = item.addTableList.sku_name
                item.field_value[i].info_date = item.addTableList.info_date
                item.field_value[i].date_name = item.addTableList.date_name
                item.field_value[i].field_value = item.addTableList.field_value
              }
            }
          } else {//新增
            item.addTableList.id = this.getUuid()
            if (item.addTableList.dept_id) {
              for (let i = 0; i < this.administrativeList.length; i++) {
                if (item.addTableList.dept_id == this.administrativeList[i].key) {
                  item.addTableList.dept_name = this.administrativeList[i].value1
                }
              }
            }
            if (item.addTableList.product_id) {
              for (let i = 0; i < this.productList.length; i++) {
                if (item.addTableList.product_id == this.productList[i].key) {
                  item.addTableList.product_name = this.productList[i].value1
                }
              }
            }
            if (item.addTableList.sku_id) {
              for (let i = 0; i < this.SkuList.length; i++) {
                if (item.addTableList.sku_id == this.SkuList[i].key) {
                  item.addTableList.sku_name = this.SkuList[i].value1
                }
              }
            }
            if (this.QUARTER) {
              item.addTableList.info_date = this.QUARTER
              let arr = this.QUARTER.split('Q')
              let year = arr[0].slice(0, 4)
              item.addTableList.date_name = `${year}年第${arr[1]}季度`
            } else if (this.WEEK) {
              item.addTableList.info_date = this.WEEK
              let arr = this.WEEK.split('W')
              let year = arr[0].slice(0, 4)
              let month = arr[0].slice(4)
              item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`

            } else {
              item.addTableList.date_name = item.addTableList.info_date
            }
            item.field_value.push(item.addTableList)
          }

          item.isAddTable = false
          item.addTableList = {
            id: '',
            dept_id: '',
            dept_name: '',
            product_id: '',
            product_name: '',
            sku_id: '',
            sku_name: '',
            info_date: '',
            date_name: '',
            field_value: '',
          }
          this.$forceUpdate()

        }
      })

    },
    cancelTableData(item) {
      item.isAddTable = false
      item.addTableList = {
        id: '',
        dept_id: '',
        dept_name: '',
        product_id: '',
        product_name: '',
        sku_id: '',
        sku_name: '',
        info_date: '',
        date_name: '',
        field_value: '',
      }
      this.$forceUpdate()
    },
    handleClickTabs(tab, event) {
      this.tabIndex = tab.index
    },
    // 门店
    async getInstitution() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        store_id: this.store_id
      }
      await http.post('/wapi/Collect/getInstitution', data).then(res => {

        if (res.success) {
          this.institutionList = res.data

        } else {
          Message.error(res.message);
        }
      })
    },
    parentEvent(data) {
      this.addTableList.info_date = data
    },
    getQuarterValue(a, b) {
      this.QUARTER = a + 'Q' + b
    },
    getWeekValue(a, b, c) {
      let month = b.toString()
      this.WEEK = a + month + 'W' + c
      console.log(this.WEEK)
    },
    parentWeekEvent(data) {
      this.addTableList.info_date = data
    },
    handleTableClick(index, row, item) {
      this.delateFalse = true
      item.isAddTable = true
      this.getSkuList(row.product_id)
      item.addTableList = {
        id: row.id,
        dept_id: row.dept_id,
        dept_name: row.dept_name,
        product_id: row.product_id,
        product_name: row.product_name,
        sku_id: row.sku_id,
        sku_name: row.sku_name,
        info_date: row.info_date,
        date_name: row.date_name,
        field_value: row.field_value,
      }
      this.$forceUpdate()
    },
    async getManager() {
      try {
        let data = {
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
        }
        await http.post('/wapi/Calendar/getManger', data).then(res => {
          this.options = res.data
          let obj = {
            user_id: '',
            user_name: '所有下属'
          }
          this.options.unshift(obj)
        })
      } catch (e) {

      }
    },
    handleSelectInputClick(user_id, str) {
      this.userIds = []
      this.GLOBAL.selectPeople_global = user_id
      if (user_id == this.GLOBAL.selectOu_global && this.GLOBAL.selectOu_global != '') {
        this.userIds.push(user_id)
        this.searchType = '部门'
      } else {
        if (user_id == this.$store.getters.getUser.user_id) {
          this.searchType = '自己'
        } else if (user_id == "0") {
          this.searchType = '直属辖区'
        } else if (user_id == '') {
          this.searchType = '所有下属'
        } else if (user_id !== this.$store.getters.getUser.user_id) {
          this.userIds.push(user_id)
          this.searchType = '多选人员'
          this.searchTerritory_id = this.GLOBAL.selectPeople_territoryId
        }
      }
      this.mydiv=0,
      this.StoreList=[]
      this.page=1
      this.getRetailStoreList()
      console.log(user_id)
    },
    guanbi2() {
      var oDiv2 = document.getElementById("div2");
      oDiv2.style.display = "none";

      var oDiv1 = document.getElementById("div1");
      oDiv1.style.display = "none";

      var oDiv3 = document.getElementById("div3");
      oDiv3.style.display = "none";

      this.dialogVisible2 = false
      for (var i = 0; i < this.extendedInfo.length; i++) {
        console.log(this.$refs, 99)
        this.$refs['list' + i][0].resetFields();
      }
      this.isfalse = false
    },
    addlist3(item) {
      var oDiv3 = document.getElementById("div3");
      oDiv3.style.display = 'block';


      var oDiv1 = document.getElementById("div1");
      oDiv1.style.display = "none";


      var oDiv2 = document.getElementById("div2");
      oDiv2.style.display = "none";
      this.storelist.comments3 = item.comments
      this.storelist.rank3 = item.segment_id
      var date = new Date();
      let yyyymmdd = ''
      let y = date.getFullYear().toString();
      let m = date.getMonth() + 1;
      if (m < 10) {
        yyyymmdd = y + '-' + '0' + m + '-01'
      } else {
        yyyymmdd = y + '-' + m + '-01'
      }
      if (item.effective == yyyymmdd) {
        this.storelist.time3 = 'D'
      } else {
        this.storelist.time3 = "C"
      }

      if (item.account_status == 'ACTIVE') {
        this.storelist.value3 = true
      } else {
        this.storelist.value3 = false
      }
    },
    addlist2(item) {
      this.account_id = item.account_id
      var oDiv = document.getElementById("div2");
      if (oDiv.style.display == "block") {
        oDiv.style.display = "none";
      } else {
        oDiv.style.display = "block";
      }
      var oDiv1 = document.getElementById("div1");
      oDiv1.style.display = "none";


      var oDiv3 = document.getElementById("div3");
      oDiv3.style.display = "none";
      this.storelist.rank2 = item.segment_id
      this.storelist.comments2 = item.comments

      var date = new Date();
      let yyyymmdd = ''
      let y = date.getFullYear().toString();
      let m = date.getMonth() + 1;
      if (m < 10) {
        yyyymmdd = y + '-' + '0' + m + '-01'
      } else {
        yyyymmdd = y + '-' + m + '-01'
      }
      if (item.effective_date == yyyymmdd) {
        this.storelist.time2 = 'D'
      } else {
        this.storelist.time2 = "C"
      }
      if (item.account_status == 'ACTIVE') {
        this.storelist.value2 = true
      } else {
        this.storelist.value2 = false
      }

    },
    baocun6() {
      if (this.activeName1 == 'first') {
        this.$refs["storelist"].validate(valid => {
          if (!valid) {
            return false
          } else {
            this.updateRetailstore()
          }
        })
      } else {
        let off = true
        if (this.extendedInfo[this.tabIndex - 1].fieldArray.length > 0) {
          for (var i = 0; i < this.extendedInfo[this.tabIndex - 1].fieldArray.length; i++) {
            if (this.extendedInfo[this.tabIndex - 1].fieldArray[i].mandatory == 'T') {
              this.$refs['list' + i][0].validate(valid => {
                console.log(valid)
                if (!valid) {
                  off = false
                }
              })
            }


          }
          if (off) {
            this.updateExtendedInfo()
          }
        }


      }

    },
    tianjia() {
      this.dialogVisible3 = true
      this.clerkadd = {
        tenant_id: "",
        retailstore_id: "",
        clerk_id: "",
        clerk_name: "",
        gender_name: "",
        manager_name: "",
        gender: "",
        mobile: "",
        email: "",
        birthday: "",
        hobby: "",
        manager: false,
        status: true,
        status_name: ""
      }
      this.$refs['clerkadd'].resetFields();
    },
    guanbi() {
      this.dialogVisible3 = false
      this.clerkadd = {}
    },
    baocun5() {
      this.$refs["clerkadd"].validate(valid => {
        if (!valid) {
          return false
        } else {
          this.addRetailstoreClerk()

        }
      })
    },
    baocun4() {
      if (this.activeName2 == 'first') {
        this.$refs["clerkClass"].validate(valid => {
          if (!valid) {
            return false
          } else {
            this.updateRetailstoreClerk()
          }
        })
      } else {
        let off = true
        if (this.extendedInfo1[this.tabIndex - 1].fieldArray.length > 0) {
          for (var i = 0; i < this.extendedInfo1[this.tabIndex - 1].fieldArray.length; i++) {
            if (this.extendedInfo1[this.tabIndex - 1].fieldArray[i].mandatory == 'T') {
              this.$refs['assistantList' + i][0].validate(valid => {
                console.log(valid)
                if (!valid) {
                  off = false
                }
              })
            }


          }
          if (off) {
            this.updateAssistantExtendedInfo()
          }
        }


      }

    },
    assistant() {
      this.dialogVisible = false
      this.extendedInfo1[this.tabIndex - 1].fieldArray = []
    },

    bianji(item) {
      this.getAdministrativeList()
      this.getProductList()
      this.clerk_id = item.clerk_id
      this.getAssistantExtendedInfo()
      this.activeName2 = 'first'
      this.store_code = item.store_code
      this.dialogVisible = true
      this.clerkClass.tenant_id = item.tenant_id
      this.clerkClass.retailstore_id = item.retailstore_id
      this.clerkClass.clerk_id = item.clerk_id
      this.clerkClass.clerk_name = item.clerk_name
      this.clerkClass.clerk_code = item.clerk_code
      this.clerkClass.gender_name = item.gender_name
      this.clerkClass.gender = item.gender
      this.clerkClass.mobile = item.mobile
      this.clerkClass.email = item.email
      this.clerkClass.birthday = item.birthday
      this.clerkClass.hobby = item.hobby

      if (item.status == 'ACTIVE') {
        this.clerkClass.status = true
      } else {
        this.clerkClass.status = false
      }

      if (item.manager == 'T') {
        this.clerkClass.manager = true
      } else {
        this.clerkClass.manager = false
      }
    },
    renyuan(value, option) {
      this.retailstore_id = ''
      this.form.people = value
      this.getRetailStoreList()
    },
    StoreAction(item, index) {
      this.hospitalInstitution_id = item.institution_id
      this.mydiv1 = 0
      this.marginValue1 = 0
      this.user_id = item.user_id
      this.retailstore_id = item.store_id
      this.territory_id = item.territory_id
      this.store_id = item.store_id
      this.getRetailstoreClerkList()
      this.getRetailstoreInfo()
      this.mydiv = index
      console.log(item)
      this.getExtendedInfo()
    },
    addlist() {
      var oDiv = document.getElementById("div1");
      if (oDiv.style.display == "block") {
        oDiv.style.display = "none";
      } else {
        oDiv.style.display = "block";
        this.isDisabled = true
      }

      var oDiv2 = document.getElementById("div2");
      oDiv2.style.display = "none";


      var oDiv3 = document.getElementById("div3");
      oDiv3.style.display = "none";


    },
    AccountDraft2() {
      this.updateAccountDraft()
      this.dialogVisible2 = false
      var oDiv2 = document.getElementById("div2");
      oDiv2.style.display = "none";
    },
    AccountDraft() {
      this.addAccountDraft()
      this.dialogVisible2 = false
      var oDiv1 = document.getElementById("div1");
      oDiv1.style.display = "none";
    },
    closelist() {
      var oDiv = document.getElementById("div1");
      if (oDiv.style.display == "block") {
        oDiv.style.display = "none";
        this.isDisabled = false
      } else {
        oDiv.style.display = "block";
      }
    },
    closelist2() {
      var oDiv = document.getElementById("div2");
      if (oDiv.style.display == "block") {
        oDiv.style.display = "none";
      } else {
        oDiv.style.display = "block";
      }
    },
    closelist3() {
      var oDiv = document.getElementById("div3");
      if (oDiv.style.display == "block") {
        oDiv.style.display = "none";
      } else {
        oDiv.style.display = "block";
      }
    },
    async getOuUserList() {


      let data = {
        user_id: this.$store.getters.getUser.user_id,
        tenant_id: this.$store.getters.getUser.tenant_id,

      }

      let self = this
      await http.post('/wapi/users/getOuUserList', data).then(res => {

        if (res.success) {
          self.UserList = res.data
          for (var i = 0; i < self.UserList.length; i++) {
            let a = self.UserList[i]
//                            if(i==0){
//                                this.form.people=a.user_id
//                            }

            if (i == 0 && self.form.people == '') {
              self.form.people = a.user_id
            }
          }

        self.loading=false
        } else {
          Message.error(res.message);
          self.loading=false

        }
      })

    },

    dianji0() {
      this.$router.push({
        path: 'fileMap',
        query: {user_id: this.$store.getters.getUser.user_id, searchType: this.searchType, userIds: this.userIds}
      })

    },
    dianji() {
      this.$router.push({
        path: 'index',
        query: {user_id: this.$store.getters.getUser.user_id, searchType: this.searchType, userIds: this.userIds}
      })

    },
    dianji2() {
      this.$router.push({
        path: 'qudao',
        query: {user_id: this.$store.getters.getUser.user_id, searchType: this.searchType, userIds: this.userIds}
      })

    },

    async getRetailStoreList() {
      this.loading = true
      let data = {
        user_id: this.form.people,
        tenant_id: this.$store.getters.getUser.tenant_id,
        userIds: this.userIds,
        searchType: this.searchType,
        territory_id:this.searchTerritory_id,//选择终端辖区人员的时候有值
        page:this.page
      }
      let self = this
      await http.post('/wapi/RetailstoreClient/getRetailStoreList', data).then(res => {

        if (res.success) {
          // self.StoreList = res.data
          self.StoreList=self.StoreList.concat(...res.data)

          self.loading = false
          if(this.page==1) {

            if (self.StoreList.length >= 0) {
              self.store_id = self.StoreList[0].store_id,
                      self.territory_id = self.StoreList[0].territory_id,
                      self.retailstore_id = self.StoreList[0].store_id
              self.user_id = self.StoreList[0].user_id
              this.getRetailstoreInfo()
              this.getRetailstoreClerkList()
              self.loading = false

            }
          }
          // this.searchType=self.StoreList.searchType
        } else {
          Message.error(res.message);
          self.loading = false
        }
        self.loading = false
      })

    },


    async getRetailstoreClerkList() {


      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        retailstore_id: this.retailstore_id
      }
      let self = this
      await http.post('/wapi/RetailstoreClient/getRetailstoreClerkList', data).then(res => {

        if (res.success) {
          self.ClerkList = res.data


        } else {
          Message.error(res.message);
        }
      })

    },

    async getRetailstoreInfo() {

      this.loading = true
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        store_id: this.store_id,
        territory_id: this.territory_id,
        user_id: this.user_id
      }
      let self = this
      await http.post('/wapi/RetailstoreClient/getRetailstoreInfo', data).then(res => {

        if (res.success) {
//                        self.ClerkList=res.data
          self.storeInfoAction = res.data[0]
          this.hospitalInstitution_id = res.data[0].store_id
          this.getLocation()
          self.storelist.store_code = res.data[0].store_code
          self.storelist.account_id = res.data[0].account_id
          self.storelist.account_status = res.data[0].account_status
          self.storelist.segment_name = res.data[0].segment_name
          self.storelist.segment_id = res.data[0].segment_id
          self.storelist.tenant_id = res.data[0].tenant_id
          self.storelist.store_id = res.data[0].store_id
          self.storelist.store_name = res.data[0].store_name
          self.storelist.store_type_name = res.data[0].store_type_name
          self.storelist.store_type = res.data[0].store_type
          self.storelist.retailstore_grade_name = res.data[0].retailstore_grade_name
          self.storelist.retailstore_grade = res.data[0].retailstore_grade
          self.storelist.province_id = res.data[0].province_id
          self.storelist.province_name = res.data[0].province_name
          self.storelist.city_id = res.data[0].city_id
          self.storelist.status = res.data[0].status
          self.storelist.city_name = res.data[0].city_name
          self.storelist.address = res.data[0].address
          self.storelist.telephone = res.data[0].telephone
          self.storelist.postcode = res.data[0].postcode
          self.storelist.website = res.data[0].website
//                        self.storelist.comments=res.data[0].comments
          self.storelist.location_id = res.data[0].location_id
          self.storelist.lat = res.data[0].lat
          self.storelist.lng = res.data[0].lng
          self.storelist.alias = res.data[0].alias
          self.storelist.AccountArray = res.data[0].AccountArray
          self.storelist.canAdd = res.data[0].canAdd


          self.storelist.old_segment_id = res.data[0].segment_id
          self.storelist.old_account_status = res.data[0].status


          this.center = [res.data[0].lng, res.data[0].lat]
          if (res.data[0].province_id != '') {
            this.getCityList(res.data[0].province_id)
          }

          if (res.data[0].account_status == 'ACTIVE') {
            self.storelist.account_status = true
          } else {
            self.storelist.account_status = false
          }

          if (res.data[0].canAdd == 'F') {
            this.isDisabled = true
          } else {
            this.isDisabled = false
          }


          this.listData = res.data[0].AccountArray

          this.loading = false


        } else {
          Message.error(res.message);
        }
        this.loading = false
      })

    },

    async getRetailstoreTypeList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      }

      let self = this
      await http.post('/wapi/Retailstore/getRetailstoreTypeList', data).then(res => {

        if (res.success) {
          self.TypeList = res.data

        } else {
          Message.error(res.message);
        }
      })
    },

    async getRetailstoreGardeList(b) {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        key: b
      }

      let self = this
      await http.post('/wapi/Retailstore/getRetailstoreGardeList', data).then(res => {

        if (res.success) {
          self.GardeList = res.data

        } else {
          Message.error(res.message);
        }
      })
    },
    fangfa2(b) {

      this.storelist.retailstore_grade_name = ''
      this.getRetailstoreGardeList(b)
    },

    async getProvinceList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      }
      let self = this
      await http.post('/wapi/Province/getProvinceList', data).then(res => {

        if (res.success) {
          self.data = res.data

        } else {
          Message.error(res.message);
        }
      })

    },
    //城市
    async getCityList(province_id) {

      let data = {
        province_id: province_id,
        tenant_id: this.$store.getters.getUser.tenant_id,
      }
      let self = this
      await http.post('/wapi/City/getCityList', data).then(res => {

        if (res.success) {
          self.CityList = res.data

        } else {
          Message.error(res.message);
        }
      })

    },
    fangfa(value, option) {

      this.getCityList(value)
      this.storelist.city_id = ''
    },


    async updateRetailstoreClerk() {

      let status = ''
      if (this.clerkClass.status == true) {
        status = 'ACTIVE'
      } else {
        status = 'INACTIVE'
      }
      let manager = ''
      if (this.clerkClass.manager == true) {
        manager = 'T'
      } else {
        manager = 'F'
      }
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        retailstore_id: this.retailstore_id,
        clerk_id: this.clerkClass.clerk_id,
        clerk_name: this.clerkClass.clerk_name,
        clerk_code: this.clerkClass.clerk_code,
        gender: this.clerkClass.gender,
        birthday: this.clerkClass.birthday,
        hobby: this.clerkClass.hobby,
        email: this.clerkClass.email,
        mobile: this.clerkClass.mobile,
        manager: manager,
        status: status
      }
      await http.post('/wapi/RetailstoreClient/updateRetailstoreClerk', data).then(res => {

        if (res.success) {
          this.dialogVisible = false
          this.getRetailstoreClerkList()
        } else {
          this.dialogVisible = true
          Message.error(res.message);
        }
      })

    },


    async addRetailstoreClerk() {

      let status = ''
      if (this.clerkadd.status == true) {
        status = 'ACTIVE'
      } else {
        status = 'INACTIVE'
      }
      let manager = ''
      if (this.clerkadd.manager == true) {
        manager = 'T'
      } else {
        manager = 'F'
      }
      let data = {
        store_code: this.storelist.store_code,
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        retailstore_id: this.retailstore_id,
        clerk_name: this.clerkadd.clerk_name,
        clerk_code: this.clerkadd.clerk_code,
        gender: this.clerkadd.gender,
        birthday: this.clerkadd.birthday,
        hobby: this.clerkadd.hobby,
        email: this.clerkadd.email,
        mobile: this.clerkadd.mobile,
        manager: manager,
        status: status
      }
      await http.post('/wapi/RetailstoreClient/addRetailstoreClerk', data).then(res => {

        if (res.success) {
          this.dialogVisible3 = false
          this.getRetailstoreClerkList()
        } else {
          this.dialogVisible3 = true
          Message.error(res.message);
        }
      })

    },

    async updateRetailstore() {

      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        store_id: this.store_id,
        store_name: this.storelist.store_name,
        store_code: this.storelist.store_code,
        store_type: this.storelist.store_type,
        retailstore_grade: this.storelist.retailstore_grade_name,
        province_id: this.storelist.province_id,
        city_id: this.storelist.city_id,
        address: this.storelist.address,
        telephone: this.storelist.telephone,
        postcode: this.storelist.postcode,
        website: this.storelist.website,
        comments: this.storelist.comments,
        status: this.storelist.status
      }
      await http.post('/wapi/RetailstoreClient/updateRetailstore', data).then(res => {

        if (res.success) {
          this.getRetailstoreInfo()
          this.getRetailStoreList()
        } else {
          Message.error(res.message);
        }
      })

    },

    async getDictionaryListByCategory() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        category: "ACCOUNT_SEGMENT",
        value2: "RETAILSTORE"
      }
      let self = this
      await http.post('/wapi/v1/getDictionaryListByCategory', data).then(res => {

        if (res.success) {
          self.Category = res.data
          this.dialogVisible2 = false
        } else {
          Message.error(res.message);
        }
        this.dialogVisible4 = false

      })
    },

    //分销客户新增
    async addAccountDraft() {
      let status = ''
      if (this.storelist.value == true) {
        status = 'ACTIVE'
      } else {
        status = 'INACTIVE'
      }
      let data = {
        territory_id: this.territory_id,
        tenant_id: this.$store.getters.getUser.tenant_id,
        account_id: this.storelist.account_id,
        account_name: this.storelist.store_name,
        account_status: status,
        effective_date: this.storelist.time,
        store_id: this.storelist.store_id,
        user_id: this.$store.getters.getUser.user_id,
        owner_id: this.user_id,
        segment_id: this.storelist.rank == null ? '' : this.storelist.rank,
        old_account_status: this.storelist.old_account_status,
        old_segment_id: this.storelist.old_segment_id,
        comments: this.storelist.comments
      }
//                let self = this
      await http.post('/wapi/RetailstoreClient/addAccountDraft', data).then(res => {

        if (res.success) {
//                        self.Category=res.data
          this.getRetailstoreInfo()

        } else {
          Message.error(res.message);
        }
        this.dialogVisible4 = false

      })
    },


    async updateAccountDraft() {
      let status = ''
      if (this.storelist.value2 == true) {
        status = 'ACTIVE'
      } else {
        status = 'INACTIVE'
      }

      let data = {
        territory_id: this.territory_id,
        tenant_id: this.$store.getters.getUser.tenant_id,
        account_id: this.account_id,
        account_name: this.storelist.store_name,
        account_status: status,
        effective_date: this.storelist.time2,
        store_id: this.storelist.store_id,
        user_id: this.$store.getters.getUser.user_id,
        segment_id: this.storelist.rank2 == null ? "" : this.storelist.rank2,
        old_account_status: this.storelist.old_account_status,
        old_segment_id: this.storelist.old_segment_id,
        comments: this.storelist.comments2
      }

      await http.post('/wapi/RetailstoreClient/updateAccountDraft', data).then(res => {

        if (res.success) {
          this.getRetailstoreInfo()

        } else {
          Message.error(res.message);
        }
        this.dialogVisible4 = false

      })
    },
    locationLeftBut() {
      if (this.mydiv1 > 1) {
        this.mydiv1 = this.mydiv1 - 1
        this.marginValue1 = this.marginValue1 + 362;
      } else if (this.mydiv1 == 1 && this.marginValue1 == 0) {
        this.mydiv1 = this.mydiv1 - 1
        this.marginValue1 = 0
      } else if (this.mydiv1 == 1 && this.marginValue1 < 0) {
        this.mydiv1 = this.mydiv1 - 1
        this.marginValue1 = 0
      }
      this.center = [this.locationInfo[this.mydiv1].lng, this.locationInfo[this.mydiv1].lat]
    },
    locationRightBut() {
      if (this.mydiv1 < this.locationInfo.length - 1) {
        this.mydiv1 = this.mydiv1 + 1
        this.marginValue1 = this.marginValue1 - 362;
      } else {
        this.marginValue1 = this.marginValue1
      }
      this.center = [this.locationInfo[this.mydiv1].lng, this.locationInfo[this.mydiv1].lat]
    },
    async getLocation() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        reference_id: this.hospitalInstitution_id,
        reference_obj: 'RETAILSTORE',
      }
      await http.post('/wapi/Institution/getLocation', data).then(res => {
        if (res.success = true) {
          console.log(res.data)
          this.locationInfo = res.data
          this.widthLocation = (this.locationInfo.length + 1) * 350 + 'px'
          if (this.locationInfo.length > 0) {
            for (var i = 0; i < this.locationInfo.length; i++) {
              this.center = [res.data[0].lng, res.data[0].lat]
              this.centers.push({
                position: [res.data[i].lng, res.data[i].lat],
                template: `<div style="width: 22px;color:#fff;height: 30px;line-height: 20px; background:url(${imgUrl})">${i + 1}</div>`
              });
            }
          } else {
            this.center = [116.46, 39.92];
            this.centers.length = 0;
            this.edit_markers.position.length = 0;
          }


        }

      })

    },
    InstitutionClient1(item, j) {
      this.mydiv1 = j
      this.marginValue1 = -((j) * 312)
      this.center = [item.lng, item.lat]
    },
    details() {
      this.getAdministrativeList()
      this.getProductList()
      this.isfalse = true
      this.activeName1 = 'first'
      this.getExtendedInfo()
      this.getInstitution()

    },


    async getExtendedInfo() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        retailstore_id: this.retailstore_id
      }
      await http.post('/wapi/Retailstore/getExtendedInfo1', data).then(res => {
debugger
        if (res.success) {
          this.extendedInfo = res.data
          if (this.extendedInfo.length > 0) {
            for (let i = 0; i < this.extendedInfo.length; i++) {
              this.extendedInfo[i].fieldArray.forEach(item => {
                if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value.indexOf('|') == -1 && item.field_value !== '') {
                  item.field_value = [item.field_value]
                }
                if (item.input_type === "LIST" && item.field_value.indexOf('|') !== -1) {
                  item.field_value = item.field_value.split('|')
                }
                if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value === '') {
                  item.field_value = []
                }
                if (item.input_type === "TABLE" && item.field_value !== '') {
                  item.field_value = JSON.parse(item.field_value)
                }
                if (item.input_type === "TABLE" && item.field_value === '') {
                  item.field_value = []
                }
                if (item.input_type === "TRUE-FALSE" && item.field_value === "") {
                  item.field_value = 'F'
                }


              })
            }
          }


        } else {
          Message.error(res.message);

        }
      })
    },

    async updateExtendedInfo() {


      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        retailstore_id: this.retailstore_id,
        ExtensionArray: this.extendedInfo[this.tabIndex - 1].fieldArray
      }
      await http.post('/wapi/Retailstore/setExtendedList', data).then(res => {

        if (res.success) {
          Message({
            type: 'success',
            message: '保存成功'
          })
          this.getExtendedInfo()
          this.dialogVisible2 = false
          this.isfalse = false
          this.extendedInfo[this.tabIndex - 1].fieldArray = []
        } else {
          Message.error(res.message);

        }
      })
    },

    async getAssistantExtendedInfo() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        clerk_id: this.clerk_id
      }
      await http.post('/wapi/Retailstore/getAssistantExtendedInfo1', data).then(res => {
debugger

        if (res.success) {
          this.extendedInfo1 = res.data
          if (this.extendedInfo1.length > 0) {
            for (let i = 0; i < this.extendedInfo1.length; i++) {
              this.extendedInfo1[i].fieldArray.forEach(item => {
                if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value.indexOf('|') == -1 && item.field_value !== '') {
                  item.field_value = [item.field_value]
                }
                if (item.input_type === "LIST" && item.field_value.indexOf('|') !== -1) {
                  item.field_value = item.field_value.split('|')
                }
                if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value === '') {
                  item.field_value = []
                }
                if (item.input_type === "TABLE" && item.field_value !== '') {
                  item.field_value = JSON.parse(item.field_value)
                }
                if (item.input_type === "TABLE" && item.field_value === '') {
                  item.field_value = []
                }
                if (item.input_type === "TRUE-FALSE" && item.field_value === "") {
                  item.field_value = 'F'
                }


              })
            }
          }


        } else {
          Message.error(res.message);

        }
      })
    },

    async updateAssistantExtendedInfo() {


      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        retailstore_id: this.retailstore_id,
        clerk_id: this.clerk_id,
        ExtensionArray: this.extendedInfo1[this.tabIndex - 1].fieldArray
      }
      await http.post('/wapi/Retailstore/setAssistantExtendedList', data).then(res => {

        if (res.success) {
          Message({
            type: 'success',
            message: '保存成功'
          })
          this.dialogVisible = false
          this.extendedInfo1[this.tabIndex - 1].fieldArray = []
        } else {
          Message.error(res.message);

        }
      })
    },

  }
}
</script>
<style lang="scss" module>
.container {
  /*padding-top: 20px;*/

  padding-bottom: 20px;
  background: #fff;

  min-height: 100%;

  .left {
    font-size: 18px;
    margin-top: -40px;
    color: #000000;

    .search {
      width: 97%;
    }

    .type {
      em {
        color: #d98f2f;
        font-size: 14px;

      }
    }

    .first {
      color: #555555;
      font-size: 14px;
    }

    .font {
      margin-left: 10px;
      line-height: 20px;
      font-size: 14px;
      color: #555555;
      position: relative;

    }
  }

  .right {
    margin-top: -20px;
    width: 100%;

    .header {
      width: 100%;
      padding-bottom: 51px;
      border-bottom: 2px dotted #e7eaec;
      margin-top: 20px;
    }

    .body {
      margin-top: 10px;
    }

  }

}
</style>
<style scoped>
.el-main {
  padding: 0px;
}

header {
  padding-right: 20px;
  padding-left: 20px;
}

.el-container {
  background-color: #fff;
}

.HcpClass >>> .home_star label:after {
  content: '*';
  color: #F56C6C;
  margin-left: 4px;
}

.DianClass >>> .home_star label:after {
  content: '*';
  color: #F56C6C;
  margin-left: 4px;
}

.subjectList >>> .home_star label:after {
  content: '*';
  color: #F56C6C;
  margin-left: 4px;
}

.subjectList >>> .el-form-item__label {
  font-size: 14px;
  color: #000000;
  text-align: left;
  font-weight: bold;
  padding-left: 20px;
}

.HcpClass >>> .el-form-item__label {
  font-weight: bold;
  color: #000;
  text-align: left;
  font-size: 14px;
  padding-left: 40px;
}

.DianClass >>> .el-form-item__label {
  font-weight: bold;
  color: #000;
  text-align: right;
  font-size: 14px;
  padding-right: 50px;
}

#DianClass1 >>> .el-form-item__label {
  font-weight: bold;
  color: #000;
  text-align: left;
  font-size: 14px;
  padding-left: 20px;
}

.People >>> .el-form-item__label {
  font-size: 18px;
  color: #000000;
  text-align: right;
}

.tableClass >>> .el-tabs__header {
  margin: 0;
}

.Peopel >>> .el-form-item__label {
  font-weight: bold;
  color: #000000;
}

#addTable .el-form-item__error {
  margin-left: 112px;
}

#addTable >>> .el-form-item__label {
  font-size: 14px;
  color: #000000;
  text-align: left;
  padding-left: 20px;
  font-weight: bold;

}

#addTableHcp .el-form-item__error {
  margin-left: 112px;
}

#addTableHcp >>> .el-form-item__label {
  font-size: 14px;
  color: #000000;
  text-align: left;
  padding-left: 20px;
  font-weight: bold;

}
</style>
<style>
#div1 {
  display: none;
}

#div2 {
  display: none;
}

#div3 {
  display: none;
}

.headerStyle > div {
  font-size: 14px;
  color: #585757;
  font-weight: bold;
}

.headerStyle:nth-last-of-type(2) > div {
  color: #4A90E2;
}

.mydiv:hover {
  background-color: #ecf3fc;
}

.mydiv {
  border: 1px solid #4A90E2;
  margin-bottom: 10px;
}

/*.mydiv:focus{*/
/*background-color: #ecf3fc;*/
/*border:1px solid #dbe9f9;*/
/*}*/
#styleClass {
  height: auto;
}
</style>





// WEBPACK FOOTER //
// src/pages/files/lingshou.vue